import React from "react";
import { Subscription } from "react-apollo";
import gql from "graphql-tag";
import { httpClient } from "settings/apolloClient";
import SUBSCRIBE_TO_ACTUATOR_CHANGES from "views/InstrumentsPanel/graphql/subscriptions/subscribeToActuatorStatusChanges.js";

// Live actuator status is kept in the httpClient normalized cache: the initial
// PLANT_LOCATIONS fetch seeds each Actuator entry and this subscription patches
// the same entry, so whoever reads PLANT_LOCATIONS (the panel) shows it live
// without polling. Renders nothing — the display is MachineStatus in the panel.
const ACTUATOR_LIVE_STATUS = gql`
  fragment ActuatorLiveStatus on Actuator {
    status
  }
`;

const writeActuatorStatus = (id, status) => {
  if (status === undefined || status === null) return;

  try {
    httpClient.writeFragment({
      id: `Actuator:${id}`,
      fragment: ACTUATOR_LIVE_STATUS,
      data: {
        __typename: "Actuator",
        status,
      },
    });
  } catch (error) {
    // no-op: the actuator is not in the cache yet (query still loading)
  }
};

const ActuatorStatusSubscriber = ({ id }) => (
  <Subscription
    subscription={SUBSCRIBE_TO_ACTUATOR_CHANGES}
    fetchPolicy="no-cache"
    variables={{ id }}
    onSubscriptionData={({ subscriptionData }) => {
      const next = subscriptionData
        && subscriptionData.data
        && subscriptionData.data.subscribeToActuatorStatusChanges;

      writeActuatorStatus(id, next);
    }}
  >
    {() => null}
  </Subscription>
);

export default ActuatorStatusSubscriber;
